<template>
    <div class="canvas-uploads">

        <h4 class="mb-3">Your Work</h4>

<!--        <pre>{{ uploads }}</pre>-->
<!--        <pre>{{ activities }}</pre>-->

        <div v-if="uploads.length" class="uploads-wrap">
            <div v-for="upload in uploads" :key="upload.id" class="upload">
                <div class="linked-activity-title" v-if="linkedActivityName( upload )">
                    {{ linkedActivityName( upload ) }}
                </div>
                <file-preview :file="upload.file"
                              :title="linkedActivityName( upload )"
                              :show-name="false"
                              :show-delete="true"
                              @delete="remove(upload)"/>
            </div>
        </div>
        <div v-else>
            <p>You haven't uploaded any work yet.</p>
        </div>

        <button type="button"
                class="btn btn-primary mt-3"
                @click="showUpload()">Add your work</button>

        <modal :id="utils.randomId({prefix: 'modal'})"
               v-if="upload.show"
               :show="true"
               @close="hideUpload()">

            <template #title>Upload your work</template>

            <div class="form-group">
                <label for="canvas-upload-activity">Select an Activity</label>
                <select v-model="upload.activity_id"
                        id="canvas-upload-activity"
                        class="form-control">
                    <option v-for="activity in activities"
                            :value="activity.id">{{ activity.element.name }}</option>
                    <option :value="null">Additional submission</option>
                </select>
            </div>

            <file-uploader v-model="upload.file"
                           storage-path="canvas-uploads"/>

            <template #footer>
                <button class="btn btn-warning"
                        type="button"
                        :disabled="upload.busy"
                        @click="hideUpload()">Cancel</button>
                <state-button class="btn btn-primary ml-auto"
                              type="button"
                              :state="upload.busy ? 'busy' : ''"
                              :disabled="!upload.file || upload.busy"
                              @click="saveUpload()">Save</state-button>
            </template>
        </modal>

    </div>
</template>

<script>
import Modal from "@/Components/Common/Modal";
import FileUploader from "@/Components/Common/FileUploader";
import {mapActions} from "vuex";
import FilePreview from "@/Components/Common/FilePreview";
import utils from "@/mixins/utils";
import StateButton from "@/Components/Common/StateButton";
export default {
    name: "CanvasUploads",
    components: {StateButton, FilePreview, FileUploader, Modal},
    mixins: [utils],

    props: ['path', 'canvas', 'stage', 'section', 'activities'],

    emits: ['uploads-changed'],

    data(){
        return {
            upload: {
                busy: false,
                show: false,
                file: null,
                activity_id: null,
            },
        }
    },


    computed: {

        uploads_canvas_key(){
            return `canvas_upload_${this.stage}_${this.section.id}`;
        },

        uploads: {
            get(){
                return typeof this.canvas?.fragments[ this.uploads_canvas_key ] === 'undefined' ? [] : this.canvas.fragments[ this.uploads_canvas_key ];
            },
            set(val){
                this.canvas.fragments[ this.uploads_canvas_key ] = val;
            },
        },

        activity_sections(){
            return typeof this.path.fragments[`stage_${this.stage}_activity_sections`] !== 'undefined' ? this.path.fragments[`stage_${this.stage}_activity_sections`] : [];
        },

        uploaded_activities(){
            return this.activities.filter( a => this.uploads.findIndex( u => u.activity_id === a.id ) >= 0 );
        },

        non_uploaded_activities(){
            return this.activities.filter( a => this.uploads.findIndex( u => u.activity_id === a.id ) < 0 );
        }

    },


    methods: {

        ...mapActions('repositories', {
            updateRepo: 'updateRepository',
        }),


        showUpload(){
            this.upload.activity_id = this.non_uploaded_activities.length ? this.non_uploaded_activities[0].id : null;
            this.upload.show = true;
        },

        hideUpload(){
            if( this.upload.busy ) return;
            this.upload.show = false;
            this.upload.file = null;
        },

        async saveUpload(){
            this.upload.busy = true;

            if( this.upload.file ){
                await this.add( this.upload.file, this.upload.activity_id );
            }

            this.upload.busy = false;

            this.hideUpload();
        },

        onUpload(){
            // TODO: Add file only set save / done.
            if( this.upload.file ){
                this.add( this.upload.file );
                this.upload.file = null;
            }
        },

        async save(){
            const fragments = {};
            fragments[ this.uploads_canvas_key ] = this.uploads;
            await this.updateRepo({scope: this.canvas.scope, fragments});
            this.$emit('uploads-changed', this.uploads);
            console.log({'uploads-changed': this.uploads});
        },

        async add(file, activity_id){
            const upload = {
                id: this.utils.randomId({prefix: 'file'}),
                activity_id,
                file
            };
            this.uploads.push(upload);
            await this.save();
        },

        async remove(upload){
            const idx = this.uploads.findIndex(item => item.id === upload.id);
            if( idx < 0 ) return;
            this.uploads.splice(idx, 1);
            await this.save();
        },

        linkedActivityName(upload){
            const activity = this.activities.find(a => a.id === upload.activity_id);
            return activity?.element?.name ? activity.element.name : 'Additional submission';
        }

    }

}
</script>

<style lang="scss" scoped>
$gap: 0.8rem;

.uploads-wrap{
    margin-left: - $gap / 2;
    margin-right: - $gap / 2;
    display: flex;
    flex-wrap: wrap;
    @media (max-width: 650px) {
        gap: 10px;
    }
}
.upload{
    position: relative;
    min-width: 200px;
    min-height: 100px;
    background-color: #ffffff;
    // flex-shrink: 1;
    // flex: 0 0 20%;
    margin-bottom: $gap;
    padding: 0 $gap / 2;
    @media (max-width: 650px) {
        flex-basis: 100%;
    }
}
.linked-activity-title{
    position: absolute;
    top: 10px;
    left: 17px;
    z-index: 1;
    padding: 0.5rem;
    background: rgba(255, 255, 255, 0.7);
    display: inline-block;
    border-radius: 0.3rem;
    color: #2b3540;
    backdrop-filter: blur(3px);
}
</style>
